// Configuración operativa del tenant (semana operativa + atribución de turnos
// que cruzan medianoche + timezone), derivada de GET /api/me.
//
// Defaults seguros mientras carga o si tenant es null: lunes / dia_inicio /
// America/Bogota — así ninguna pantalla parpadea con la semana mal ordenada
// (con dia_inicio_semana=1 todo se comporta igual que la semana ISO clásica).

import { useMe } from './queries';
import { FORMATO_LOTE_DEFAULT, type FormatoLote } from '../formatoLote';

export interface TenantConfig {
  /** Día de inicio de la semana operativa (ISO: 1=lunes … 7=domingo). */
  diaInicioSemana: number;
  /** Día operativo EN CURSO (YYYY-MM-DD) — LA definición de "Hoy" de la
   *  plataforma, servida por /api/me. Con `dia_fin`, a las 22:00 ya se opera
   *  el día siguiente. Fallback: fecha calendario del navegador. */
  hoyOperativo: string;
  /** A qué día operativo se atribuye un turno que cruza medianoche. */
  atribucionCruce: 'dia_inicio' | 'dia_fin';
  /** Timezone IANA del tenant. */
  timezone: string;
  /** Formato del lote/OP de captura de la empresa (B7). Default: 8 dígitos. */
  formatoLote: FormatoLote;
}

function hoyLocalIso(): string {
  const now = new Date();
  return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()))
    .toISOString()
    .slice(0, 10);
}

export function useTenantConfig(): TenantConfig {
  const me = useMe();
  const tenant = me.data?.tenant ?? null;
  return {
    diaInicioSemana: tenant?.dia_inicio_semana ?? 1,
    hoyOperativo: me.data?.dia_operativo_hoy ?? hoyLocalIso(),
    atribucionCruce: tenant?.atribucion_turno_cruce ?? 'dia_inicio',
    timezone: tenant?.timezone ?? 'America/Bogota',
    formatoLote: tenant
      ? {
          regex: tenant.formato_lote_regex ?? FORMATO_LOTE_DEFAULT.regex,
          ejemplo: tenant.formato_lote_ejemplo ?? FORMATO_LOTE_DEFAULT.ejemplo,
          ayuda: tenant.formato_lote_ayuda ?? FORMATO_LOTE_DEFAULT.ayuda,
        }
      : FORMATO_LOTE_DEFAULT,
  };
}
